<template>
  <v-container fluid fill-height>
    <v-flex sm12>
      <v-toolbar
        color="#eee"
        class="elevation-0 secondary--text mb-4"
        style="background: transparent"
      >
        <v-layout row wrap justify-space-around class="mt-2">
          <v-flex xs12 sm3>
            <v-toolbar-title>Vendas Pos-Pagas</v-toolbar-title>
          </v-flex>
          <v-flex xs12 sm3>
            <v-select
              :items="[
                {text: 'Selecione um filtro', value: null},
                {text: 'Vendas para Clientes', value: 1},
                {text: 'Vendas para Empresas', value: 2},
                {text: 'Vendas Canceladas', value: 3}
              ]"
              label="filtrar por"
              v-model="filtro"
            />
          </v-flex>
          <v-flex xs12 sm3 class="mb-2" v-if="frentista.gerente == true && listaVouches && listaVouches.results.length > 1">
            <v-btn block color="primary" @click="dialogPin = true">Dar baixa em todos</v-btn>
          </v-flex>
        </v-layout>
      </v-toolbar>
      <v-layout
        row
        wrap
        justify-space-between
        v-if="listaVouches && listaVouches.results.length > 0"
      >
        <v-flex
          v-for="(precompra, index) in listaVouches.results"
          :key="index"
          md5
          xs12
        >
          <template>
            <v-menu
              offset-x
              :key="precompra.codigo"
              left
              transition="slide-x-reverse-transition"
            >
              <template v-slot:activator="{ on }">
                <card-compra
                  :key="`${index}-card`"
                  v-on="on"
                  :footer="true"
                  :on="on"
                  :cor="pegarCor(precompra)"
                >
                <template v-slot:icone>
                  <v-tooltip
                    v-if="precompra.combustivel"
                    :color="pegarCor(precompra)"
                    top
                  >
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <svg-filler
                          :path="
                            precompra.combustivel.icone
                              ? require(`@/assets/combs/${precompra.combustivel.icone}.svg`)
                              : require(`@/assets/combs/gas.svg`)
                          "
                          width="40px"
                          height="40px"
                          :fill="pegarCor(precompra)"
                        />
                      </span>
                    </template>
                    <span>{{ precompra.combustivel.nome }}</span>
                  </v-tooltip>
                  <v-tooltip
                    v-else-if="precompra.pedido && precompra.pedido.itens && precompra.pedido.itens.length > 0"
                    :color="pegarCor(precompra)"
                    top
                  >
                    <template v-slot:activator="{ on }">
                      <svg-filler
                          v-on="on"
                          v-if="precompra.pedido.itens[0].item.combustivel"
                          :path="
                            precompra.pedido.itens[0].item.combustivel.icone
                              ? require(`@/assets/combs/${precompra.pedido.itens[0].item.combustivel.icone}.svg`)
                              : require(`@/assets/combs/gas.svg`)
                          "
                          width="40px"
                          height="40px"
                          :fill="pegarCor(precompra)"
                      />
                      <v-icon
                        v-else
                        v-on="on"
                        :color="pegarCor(precompra)"
                      >
                        {{ pegarIcone(precompra) }}
                      </v-icon>
                    </template>
                    <span>{{ pegarTexto(precompra) }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:principal>
                  <v-list-tile-content
                      class="mt-3"
                      style="height: 105px; font-size: 11pt; font-weight: bold"
                    >
                      <v-list-tile-title>
                        {{ (frentista && frentista.empresa) ? 'Valor da compra:' : 'Valor a abastecer:' }} {{precompra.valor_total | currency({ fractionCount: 2 })}}
                      </v-list-tile-title>
                      <v-list-tile-sub-title v-if="precompra.valor" class="grey--text text--darken-3 caption font-weight-medium">
                        Valor a pagar: {{ precompra.valor | currency({ fractionCount: 2 }) }}
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title
                        class="grey--text text--darken-3 caption font-weight-medium"
                        v-if="!precompra.empresa && precompra.desconto"
                      >
                        {{
                          formatarDesconto(precompra.desconto)
                        }}
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title
                        class="grey--text text--darken-3 caption font-weight-medium"
                        v-else-if="precompra.desconto"
                      >
                        Desconto: {{formatarDesconto(precompra.desconto)}}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                </template>
                <template v-slot:dados_usuario>
                  <v-layout column align-center justify-center fill-height>
                    <v-tooltip top lazy>
                      <template v-slot:activator="{ on }">
                        <v-flex v-on="on" shrink>
                          <v-layout fill-height align-end>
                            <v-avatar size="45" v-if="precompra">
                              <img
                                v-if="precompra.cliente && precompra.cliente.pessoa.url_imagem_perfil && !precompra.empresa"
                                :src="precompra.cliente.pessoa.url_imagem_perfil"
                              />
                              <v-icon v-else-if="precompra.empresa" color="green darken-2">mdi-domain</v-icon>
                              <v-icon size="45" v-else>face</v-icon>
                            </v-avatar>
                          </v-layout>
                        </v-flex>
                      </template>
                      <span v-if="precompra.cliente">
                        {{ precompra.cliente.pessoa.nome }}
                        {{ precompra.cliente.pessoa.sobrenome }}
                      </span>
                      <span v-else-if="precompra.empresa">{{precompra.empresa.nome_fantasia}}</span>
                    </v-tooltip>
                    <v-flex
                      v-if="precompra.cliente && !precompra.empresa"
                      class="grey--text text--darken-4 caption font-weight-medium"
                      shrink
                    >
                      {{ precompra.cliente.pessoa.nome }}
                    </v-flex>
                    <v-flex
                      v-if="precompra.veiculo"
                      class="grey--text text--darken-4 caption font-weight-medium"
                      shrink
                    >
                      {{ precompra.veiculo.identificacao }}
                    </v-flex>
                    <v-flex
                      v-if="precompra.veiculo"
                      class="grey--text text--darken-4 caption font-weight-medium"
                      shrink
                    >
                      {{ precompra.veiculo.modelo_marca }}
                    </v-flex>
                    <v-flex
                      v-if="precompra.empresa"
                      class="grey--text text--darken-4 caption font-weight-medium"
                      shrink
                    >
                      {{ precompra.empresa.nome_fantasia }}
                    </v-flex>
                  </v-layout>
                </template>
                <template v-slot:footer>
                  <v-flex xs4 class="centro">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <b>
                            {{
                              precompra.data_compra.split("-").reverse().join("/")
                            }}
                          </b>
                        </span>
                      </template>
                      <span>Data da Compra</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex xs4 class="centro">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <b>
                            {{
                              precompra.codigo || 'NÃO POSSUI CÓDIGO'
                            }}
                          </b>
                        </span>
                      </template>
                      <span>Código da Compra</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex xs4 class="centro">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <b>
                            {{
                              precompra.tipo_pagamento
                            }}
                          </b>
                        </span>
                      </template>
                      <span>Forma de Pagamento</span>
                    </v-tooltip>
                  </v-flex>
                </template>
                </card-compra>
              </template>
              <v-list>
                <template>
                  <v-list-tile ripple v-if="!precompra.cancelado">
                    <v-list-tile-content>
                      <v-list-tile-title
                        @click="
                          precompraSelecionado = precompra,
                          dialogDetalhes = true
                        "
                        class="body-2 primary--text text-xs-center "
                        style="cursor: pointer"
                        >VISUALIZAR</v-list-tile-title
                      >
                    </v-list-tile-content>
                    <v-list-tile-avatar>
                      <v-icon color="primary">visibility</v-icon>
                    </v-list-tile-avatar>
                  </v-list-tile>
                  <v-list-tile
                    ripple
                    @click="cancelarCompra(precompra)"
                    v-if="!precompra.cancelado"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title class="body-2 error--text text-xs-center "
                        >CANCELAR COMPRA</v-list-tile-title
                      >
                    </v-list-tile-content>
                    <v-list-tile-avatar>
                      <v-icon color="error">close</v-icon>
                    </v-list-tile-avatar>
                  </v-list-tile>
                  <v-list-tile ripple v-else>
                    <v-list-tile-content>
                      <v-list-tile-title class="body-2 error--text text-xs-center"
                        >COMPRA CANCELADA
                        {{
                          precompra.data_cancelamento
                            ? " DIA " +
                              precompra.data_cancelamento
                                .split("-")
                                .reverse()
                                .join("/")
                            : ""
                        }}</v-list-tile-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile ripple @click="copyCodigo(precompra.codigo)">
                    <v-list-tile-content>
                      <v-list-tile-title
                        class="text-xs-center body-2 info--text"
                        >COPIAR CÓDIGO DA COMPRA</v-list-tile-title
                      >
                    </v-list-tile-content>
                    <v-list-tile-avatar>
                      <v-icon color="info">content_copy</v-icon>
                    </v-list-tile-avatar>
                  </v-list-tile>
                </template>
              </v-list>
            </v-menu>
          </template>
        </v-flex>
      </v-layout>
      <h2 v-else class="text-xs-center primary--text">
        NÃO HÁ VENDAS PARA DAR BAIXA
      </h2>
      <div class="text-xs-center">
        <v-pagination
          v-model="pagination.page"
          :length="pages"
          circle
        ></v-pagination>
      </div>
    </v-flex>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.xs"
      v-if="dialogCancelamento"
      v-model="dialogCancelamento"
      persistent
      max-width="500"
    >
      <dialog-cancelar-compra
        v-if="dialogCancelamento"
        @fechar="dialogCancelamento = false"
        :compra="precompraSelecionado"
      />
    </v-dialog>
    <v-dialog v-model="dialogPin" v-if="dialogPin" persistent max-width="360">
        <aviso-baixa-em-todas @autenticado="darBaixaEmTodos" @fechar="dialogPin = false"/>
    </v-dialog>
    <v-dialog v-model="dialogDetalhes" v-if="dialogDetalhes" width="50em">
      <dialog-detalhes-compra
        @fechar="dialogDetalhes= false, precompraSelecionado=undefined"
        :compra="precompraSelecionado"
        @concluido="concluido"
        :tipo="'pospago'"
      />
    </v-dialog>
  </v-container>
</template>

<script>

import DialogCancelarCompra from '@/components/dialogs/DialogCancelamentoCompras'
import AvisoBaixaEmTodas from '@/components/dialogs/AvisoBaixaEmTodas'
import DialogDetalhesCompra from '@/components/dialogs/DetalhesCompra'
import CardCompra from '@/components/CardCompra'

export default {
  components: { DialogCancelarCompra, AvisoBaixaEmTodas, DialogDetalhesCompra, CardCompra },
  data: () => ({
    pagination: {
      rowsPerPage: 6,
      page: 1
    },
    dialogPin: false,
    filtro: null,
    compra: undefined,
    dialogDetalhes: false,
    listaVouches: { results: [] },
    precompraSelecionado: null,
    dialogCancelamento: false,
    cancelado: false,
    texto: 'Copiar Código da Compra',
    color: ''
  }),
  computed: {
    frentista () {
      return this.$store.getters.frentista
    },
    loading () {
      return this.$store.getters.loading
    },
    pages () {
      let count = this.listaVouches.count
      if (this.pagination.rowsPerPage == null || count == null) return 0

      return Math.ceil(count / this.pagination.rowsPerPage)
    },
    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },
    posto () {
      return this.$store.getters.posto
    },
    empresa () {
      return this.$store.getters.empresa
    },
    mes () {
      const numeroDoMes = this.picker ? Number(this.picker.split('-')[1]) : 1
      switch (numeroDoMes) {
        case 1:
          return 'Janeiro'
        case 2:
          return 'Fevereiro'
        case 3:
          return 'Março'
        case 4:
          return 'Abril'
        case 5:
          return 'Maio'
        case 6:
          return 'Junho'
        case 7:
          return 'Julho'
        case 8:
          return 'Agosto'
        case 9:
          return 'Setembro'
        case 10:
          return 'Outubro'
        case 11:
          return 'Novembro'
        case 12:
          return 'Dezembro'
        default:
          return 'Mês inválido'
      }
    }
  },
  watch: {
    'pagination.page': {
      handler (val, oldval) {
        if (this.frentista) this.carregarcompras()
      },
      deep: true
    },
    filtro (val) {
      if (this.frentista) this.carregarcompras()
    },
    frentista (val) {
      if (val) this.carregarcompras()
    }
  },
  beforeMount () {
    if (this.frentista) {
      this.carregarcompras()
    }
  },
  methods: {
    formatarDesconto (desconto) {
      if (!desconto) return '0%'
      else if (desconto % 1 !== 0) {
        return `R$ ${desconto.toFixed(2).replace('.', ',')}`
      }
      return `${desconto}%`
    },
    pegarCor (precompra) {
      if (precompra.combustivel) {
        return precompra.combustivel.color
      } else if (precompra.pedido && precompra.pedido.itens && precompra.pedido.itens.length > 0) {
        const item = precompra.pedido.itens[0].item
        if (item.combustivel) {
          return item.combustivel.color
        } else {
          return item.categoria.cor
        }
      }
      return 'info'
    },
    pegarTexto (precompra) {
      if (precompra.combustivel) {
        return precompra.combustivel.nome
      } else if (precompra.pedido && precompra.pedido.itens && precompra.pedido.itens.length > 0) {
        const item = precompra.pedido.itens[0].item
        if (item.combustivel) {
          return item.combustivel.nome
        } else {
          return item.categoria.nome
        }
      }
      return 'Não informado'
    },
    pegarIcone (precompra) {
      if (precompra.combustivel) {
        return precompra.combustivel.icone
      } else if (precompra.pedido && precompra.pedido.itens && precompra.pedido.itens.length > 0) {
        const item = precompra.pedido.itens[0].item
        if (item.combustivel) {
          return item.combustivel.icone
        } else {
          return item.categoria.icone
        }
      }
      return 'Não informado'
    },
    concluido () {
      this.carregarcompras()
      this.precompraSelecionado = null
    },
    darBaixaEmTodos () {
      this.$store.dispatch('darBaixarEmTodos', {
        'cnpj': this.frentista.posto.cnpj
      }).then(() => {
        this.carregarcompras()
      })
    },
    carregarcompras () {
      const data = {
        page: this.pagination.page,
        cancelado: this.filtro === 3
      }
      if (this.filtro === 1) {
        data.empresa_id__isnull = true
        data.cliente_id__isnull = false
      } else if (this.filtro === 2) {
        data.empresa_id__isnull = false
        data.cliente_id__isnull = true
      }
      this.$store.dispatch('comprasEmDinheiro', data).then(value => {
        this.listaVouches = value
      })
    },
    copyCodigo (codigo) {
      navigator.clipboard.writeText(codigo)
      alert('Copiado')
      this.texto = 'Copiado'
      this.color = 'green'
      let interval = setInterval(() => {
        this.texto = 'Copiar Código'
        this.color = ''
        clearInterval(interval)
      }, 500)
    },
    cancelarCompra (compra) {
      this.precompraSelecionado = compra
      this.dialogCancelamento = true
    }
  }
}
</script>

<style scoped>

.centro {
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
